// extracted by mini-css-extract-plugin
export var background = "_5m-0";
export var container = "_5m-1";
export var contentItem = "_5m-7";
export var extendedWarranty = "_5m-5";
export var link = "_5m-d";
export var modal = "_5m-b";
export var modalCloseButton = "_5m-9";
export var modalContent = "_5m-3";
export var modalContentMain = "_5m-6";
export var modalImageLogo = "_5m-8";
export var modalLogo = "_5m-a";
export var modalSideImage = "_5m-4";
export var preview = "_5m-c";
export var redoModal = "_5m-2";